export const money = (v) =>
    new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" }).format(Number(v || 0));

export const dateFmt = (s) => {
    if (!s) return "—";
    try {
        const m = typeof s === "string" && s.match(/^(\d{4})-(\d{2})-(\d{2})$/);
        const d = m ? new Date(+m[1], +m[2] - 1, +m[3]) : new Date(s);
        return d.toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" });
    } catch {
        return s;
    }
};

const MAP = {
    draft: { label: "Draft", cls: "bg-slate-100 text-slate-700 border-slate-200" },
    submitted: { label: "Submitted", cls: "bg-sky-50 text-sky-800 border-sky-200" },
    in_approval: { label: "In Approval", cls: "bg-amber-50 text-amber-800 border-amber-200" },
    approved: { label: "Approved", cls: "bg-emerald-50 text-emerald-800 border-emerald-200" },
    po_issued: { label: "PO Issued", cls: "bg-emerald-50 text-emerald-800 border-emerald-200" },
    rejected: { label: "Rejected", cls: "bg-rose-50 text-rose-800 border-rose-200" },
    uploaded: { label: "Uploaded", cls: "bg-slate-100 text-slate-700 border-slate-200" },
    in_review: { label: "In Review", cls: "bg-indigo-50 text-indigo-800 border-indigo-200" },
    awaiting_review: { label: "Awaiting Review", cls: "bg-amber-50 text-amber-800 border-amber-200" },
    matched: { label: "Matched", cls: "bg-emerald-50 text-emerald-800 border-emerald-200" },
    posted: { label: "Posted to Veracross", cls: "bg-sky-50 text-sky-800 border-sky-200" },
    exception: { label: "Exception", cls: "bg-rose-50 text-rose-800 border-rose-200" },
    open: { label: "Open", cls: "bg-amber-50 text-amber-800 border-amber-200" },
    partially_invoiced: { label: "Partially Invoiced", cls: "bg-indigo-50 text-indigo-800 border-indigo-200" },
    closed: { label: "Closed", cls: "bg-emerald-50 text-emerald-800 border-emerald-200" },
    active: { label: "Active", cls: "bg-emerald-50 text-emerald-800 border-emerald-200" },
    trialing: { label: "Trial", cls: "bg-sky-50 text-sky-800 border-sky-200" },
    past_due: { label: "Past Due", cls: "bg-amber-50 text-amber-800 border-amber-200" },
    canceled: { label: "Canceled", cls: "bg-rose-50 text-rose-800 border-rose-200" },
    suspended: { label: "Suspended", cls: "bg-rose-50 text-rose-800 border-rose-200" },
};

export const statusMeta = (s) => MAP[s] || { label: s, cls: "bg-slate-100 text-slate-700 border-slate-200" };

export const roleLabel = (r) =>
    ({
        platform_admin: "Platform Admin", school_admin: "School Admin", purchasing_admin: "Purchasing Admin",
        requester: "Requester", approver: "Approver",
        super_admin: "Platform Admin", tenant_admin: "School Admin", ap_clerk: "Purchasing Admin",
    }[r] || r);

export const userRoles = (user) =>
    user?.roles && user.roles.length ? user.roles : user?.role ? [user.role] : [];

export const hasRole = (user, roles) => {
    const rs = userRoles(user);
    const arr = Array.isArray(roles) ? roles : [roles];
    return arr.some((r) => rs.includes(r));
};

export const formatErr = (detail) => {
    if (detail == null) return "Something went wrong. Please try again.";
    if (typeof detail === "string") return detail;
    if (Array.isArray(detail))
        return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
    if (detail && typeof detail.msg === "string") return detail.msg;
    return String(detail);
};
